import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { categories } from '@/mocks/data';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location]);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md shadow-sm'
          : 'bg-transparent'
      }`}
    >
      <div className="flex items-center justify-between h-16 md:h-18 px-4 md:px-8">
        <Link to="/" className="flex items-center gap-2 whitespace-nowrap">
          <span className="text-xl md:text-2xl font-heading font-bold text-foreground-900">
            51<span className="text-accent-500">吃瓜</span>
          </span>
        </Link>

        <div className="hidden md:flex items-center gap-6">
          <Link
            to="/"
            className={`text-sm font-medium transition-colors whitespace-nowrap ${
              location.pathname === '/'
                ? 'text-accent-600'
                : 'text-foreground-700 hover:text-foreground-900'
            }`}
          >
            首页
          </Link>
          {categories.slice(0, 4).map((cat) => (
            <Link
              key={cat.slug}
              to="/category/all"
              className={`text-sm font-medium transition-colors whitespace-nowrap ${
                location.pathname === '/category/all'
                  ? 'text-accent-600'
                  : 'text-foreground-700 hover:text-foreground-900'
              }`}
            >
              {cat.name}
            </Link>
          ))}
          <Link
            to="/about"
            className={`text-sm font-medium transition-colors whitespace-nowrap ${
              location.pathname === '/about'
                ? 'text-accent-600'
                : 'text-foreground-700 hover:text-foreground-900'
            }`}
          >
            关于我们
          </Link>
        </div>

        <button
          className="hidden md:flex items-center gap-2 px-4 py-2 rounded-full bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
        >
          <i className="ri-chat-smile-2-line w-4 h-4 flex items-center justify-center"></i>
          我要爆料
        </button>

        <button
          onClick={() => setMobileOpen(!mobileOpen)}
          className="md:hidden w-10 h-10 flex items-center justify-center text-foreground-800 cursor-pointer"
        >
          <i className={`${mobileOpen ? 'ri-close-line' : 'ri-menu-line'} text-xl`}></i>
        </button>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200 px-4 py-4 flex flex-col gap-3">
          <Link to="/" className="text-sm font-medium text-foreground-800 py-2">首页</Link>
          {categories.slice(0, 4).map((cat) => (
            <Link
              key={cat.slug}
              to="/category/all"
              className="text-sm font-medium text-foreground-800 py-2"
            >
              {cat.name}
            </Link>
          ))}
          <Link to="/about" className="text-sm font-medium text-foreground-800 py-2">关于我们</Link>
          <button className="mt-2 px-4 py-2 rounded-full bg-primary-500 text-background-50 text-sm font-medium cursor-pointer whitespace-nowrap text-center">
            <i className="ri-chat-smile-2-line mr-1"></i>我要爆料
          </button>
        </div>
      )}
    </nav>
  );
}